import React from 'react'
import {
  DsButton,
  DsStack,
  DsTextArea,
  DsTextField
} from '@am92/react-design-system'
import { Form as FormikForm, Formik, FormikProps } from 'formik'

import getWithPageConstants, {
  IWithPageConstantsProps
} from '~/src/Hocs/withPageConstants'

import { INITIAL_VALUES, VALIDATION_SCHEMA } from './ContactUsForm.Constants'
import CONTACT_US_FORM_PAGE_CONSTANTS from './ContactUsForm.PageConstants'
import { T_CONTACT_US_FORM_PAGE_CONSTANTS } from './ContactUsForm.PageConstants/TYPES'
import { T_CONTACT_US_FORM } from './ContactUsForm.Types'

export interface IContactUsFormProps {
  formValues?: T_CONTACT_US_FORM
  onSubmit: (values: T_CONTACT_US_FORM) => void | Promise<void>
}

const ContactUsForm: React.FC<
  IContactUsFormProps &
    IWithPageConstantsProps<T_CONTACT_US_FORM_PAGE_CONSTANTS>
> = props => {
  const { PAGE_CONSTANTS, formValues, onSubmit } = props

  function renderForm(formikBag: FormikProps<T_CONTACT_US_FORM>) {
    const { values, errors, touched, handleChange, handleBlur, isSubmitting } =
      formikBag

    const isButtonDisabled = !!Object.keys(errors).length || isSubmitting

    return (
      <FormikForm>
        <DsStack direction='column' spacing='var(--ds-spacing-glacial)'>
          <DsStack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{
              xs: 'var(--ds-spacing-glacial)',
              md: 'var(--ds-spacing-warm)'
            }}
          >
            <DsTextField
              fullWidth
              placeholder={PAGE_CONSTANTS.FULL_NAME_PLACEHOLDER}
              label={PAGE_CONSTANTS.FULL_NAME_LABEL}
              name='fullName'
              value={values.fullName}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                (touched.fullName &&
                  PAGE_CONSTANTS[
                    errors.fullName as keyof T_CONTACT_US_FORM_PAGE_CONSTANTS
                  ]) ||
                ' '
              }
              error={touched.fullName && !!errors.fullName}
            />
            <DsTextField
              fullWidth
              placeholder={PAGE_CONSTANTS.EMAIL_ID_PLACEHOLDER}
              label={PAGE_CONSTANTS.EMAIL_ID_LABEL}
              name='emailId'
              value={values.emailId}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                (touched.emailId &&
                  PAGE_CONSTANTS[
                    errors.emailId as keyof T_CONTACT_US_FORM_PAGE_CONSTANTS
                  ]) ||
                ' '
              }
              error={touched.emailId && !!errors.emailId}
            />
          </DsStack>

          <DsTextField
            fullWidth
            placeholder={PAGE_CONSTANTS.SUBJECT_PLACEHOLDER}
            label={PAGE_CONSTANTS.SUBJECT_LABEL}
            name='subject'
            value={values.subject}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={
              (touched.subject &&
                PAGE_CONSTANTS[
                  errors.subject as keyof T_CONTACT_US_FORM_PAGE_CONSTANTS
                ]) ||
              ' '
            }
            error={touched.subject && !!errors.subject}
          />

          <DsTextArea
            fullWidth
            maxLength={500}
            minRows={5}
            maxRows={5}
            placeholder={PAGE_CONSTANTS.MESSAGE_PLACEHOLDER}
            label={PAGE_CONSTANTS.MESSAGE_LABEL}
            name='message'
            value={values.message}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={
              (touched.message &&
                PAGE_CONSTANTS[
                  errors.message as keyof T_CONTACT_US_FORM_PAGE_CONSTANTS
                ]) ||
              ' '
            }
            error={touched.message && !!errors.message}
          />

          <DsStack direction='row' justifyContent='flex-end'>
            <DsButton
              size='large'
              type='submit'
              disabled={isButtonDisabled}
              sx={{ minWidth: '120px' }}
            >
              {PAGE_CONSTANTS.SEND_CTA_TEXT}
            </DsButton>
          </DsStack>
        </DsStack>
      </FormikForm>
    )
  }

  return (
    <Formik
      initialValues={formValues || INITIAL_VALUES}
      validationSchema={VALIDATION_SCHEMA}
      validateOnChange
      validateOnMount
      onSubmit={onSubmit}
    >
      {renderForm}
    </Formik>
  )
}

const withPageConstants =
  getWithPageConstants<T_CONTACT_US_FORM_PAGE_CONSTANTS>(
    CONTACT_US_FORM_PAGE_CONSTANTS
  )

export default withPageConstants(ContactUsForm)
